import { useMQTTCommand } from "../../../../hooks/useMQTTCommand"
import { useLanguage } from "../../../../contexts/language-context"
import { DeviceDocument } from "../../../../contexts/devices-context"
import { Group } from "@mantine/core"
import RequiresRole from "../../../auth/components/require-auth/RequiresRole"
import ConfirmModal from "../../../devices/components/confirm-modal/ConfirmModal"
import { IconCircleX, IconCloudUpload, IconSend, IconTrash } from "@tabler/icons-react"

const UploadCommands = ({ organisation, group, device, disabled }: {
    organisation: string
    group: string
    device: DeviceDocument
    disabled: boolean
}) => {
    const { L } = useLanguage()

    const cleanCommand = useMQTTCommand("upload_client/clean", organisation, group, device)
    const startUploadAllCommand = useMQTTCommand("upload_client/start_upload_all", organisation, group, device)
    const stopUploadAllCommand = useMQTTCommand("upload_client/stop_upload_all", organisation, group, device)

    return (
        <Group spacing="xs">
            <RequiresRole role="admin">
                <ConfirmModal
                    loading={cleanCommand.processing}
                    modalButton={{
                        text: L("Send Command"),
                        leftIcon: <IconSend size={16} />,
                        onClick: cleanCommand.send,
                        disabled
                    }}
                    openButton={{
                        leftIcon: <IconTrash size={16} />,
                        text: L("Clean Storage"),
                        disabled,
                    }}
                >
                    {L("Are you sure you want to delete uploaded files from %s?", device.id)}
                </ConfirmModal>
            </RequiresRole>

            <ConfirmModal
                loading={startUploadAllCommand.processing || stopUploadAllCommand.processing}
                modalButton={{
                    text: L("Send Command"),
                    leftIcon: <IconSend size={16} />,
                    onClick: startUploadAllCommand.send,
                    disabled
                }}
                openButton={{
                    leftIcon: <IconCloudUpload size={16} />,
                    text: L("Start Upload All"),
                    disabled,
                }}
            >
                {L("Are you sure you want to start uploading all files on %s?", device.id)}
            </ConfirmModal>

            <ConfirmModal
                loading={startUploadAllCommand.processing || stopUploadAllCommand.processing}
                modalButton={{
                    text: L("Send Command"),
                    leftIcon: <IconSend size={16} />,
                    onClick: stopUploadAllCommand.send,
                    disabled
                }}
                openButton={{
                    leftIcon: <IconCircleX size={16} />,
                    text: L("Stop Upload All"),
                    disabled,
                }}
            >
                {L("Are you sure you want to stop uploading all files on %s?", device.id)}
            </ConfirmModal>
        </Group>
    )
}

export default UploadCommands